(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-sound-enabled.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-sound-enabled.js');
"use strict";


const {
  useState
} = React;
const USERS_PREFERRED_SOUND_STATUS_KEY = 'userSoundStatus';
const TICKET_GAMES_SCRATCH_GAMES_DOMAIN = 'svs.ticketgames.ticketUtility.scratchGames';
const EXPIRATION = svs.components.Storage.constants.EXPIRES_24H;
const useSoundEnabled = _ref => {
  let {
    ticketInfo
  } = _ref;
  const shouldSaveUsersPreferredSoundStatus = () => {
    const catergories = ['Triss', 'Skrapspel'];
    return ticketInfo.hasSound && catergories.includes(ticketInfo.category);
  };
  const getUsersPreferredSoundStatus = () => {
    if (shouldSaveUsersPreferredSoundStatus()) {
      return svs.components.Storage.browser.get(USERS_PREFERRED_SOUND_STATUS_KEY, TICKET_GAMES_SCRATCH_GAMES_DOMAIN);
    }
  };
  const setUsersPreferredSoundStatus = soundStatus => {
    if (shouldSaveUsersPreferredSoundStatus()) {
      return svs.components.Storage.browser.set(USERS_PREFERRED_SOUND_STATUS_KEY, TICKET_GAMES_SCRATCH_GAMES_DOMAIN, soundStatus, EXPIRATION);
    }
  };
  const {
    hasSound,
    hasSoundDefaultOn
  } = ticketInfo;
  const [usersSavedSoundStatus] = useState(getUsersPreferredSoundStatus());
  const soundEnabled = hasSound && (usersSavedSoundStatus !== null && usersSavedSoundStatus !== void 0 ? usersSavedSoundStatus : hasSoundDefaultOn);
  return {
    hasSound,
    hasSoundDefaultOn,
    setUsersSavedSoundStatus: setUsersPreferredSoundStatus,
    soundEnabled,
    usersSavedSoundStatus
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useSoundEnabled', useSoundEnabled);

 })(window);